<template>
	<div id="sidemenu" :class="classes">
		<ul v-if="!disabledOptions">
			<side-bar-item v-for="item in items" :key="randomId(item)" :item="item" @inactiveBrothersItems="inactiveBrothersItems" @activeParentItem="activeParentItem(item)"/>
			<li class="exit">
				<a @click="logout">Cerrar sesión</a>
			</li>
		</ul>
		<ul v-else>
			<li>
				<a href="/">RESUMEN GENERAL</a>
			</li>
			<li class="disabled">
				<a>NIVEL ESCOLAR</a>
			</li>
			<li class="disabled">
				<a>IDIOMAS</a>
			</li>
			<li class="disabled">
				<a>DOCENTES</a>
			</li>
			<side-bar-item v-if="checkPermissions()" v-for="item in items.slice(4)" :key="randomId(item)" :item="item" @inactiveBrothersItems="inactiveBrothersItems" @activeParentItem="activeParentItem(item)"/>
			<li class="exit">
				<a @click="logout">Cerrar sesión</a>
			</li>
		</ul>
	</div>
</template>

<script>
import Auth from '@/services/Auth';
import Permissions from '@/services/Permissions';
export default {
	props: ['disabledOptions'],
	computed: {
		currentRoute () {
			return this.$route.fullPath;
		},
		items () {
			return this.$store.state.ui.sideMenu;
		},
		user () {
			return this.$store.state.session.currentUser;
		},
		classes () {
			if (!this.$store.state.ui.showingSideMenu) return 'sideMenu';
			else return 'sideMenu show';
		}
	},
	methods: {
		checkPermissions () {
			return Permissions.compareRoles(['SUPER-ADMIN', 'ADMINISTRATION', 'COACHING', 'EXECUTIVE'], Auth.getDecodedToken().scope);
		},
		logout () {
			Auth.logout();
		},
		randomId (item) {
			return `${item.title}-${Math.random().toString(36).substring(7)}`;
		},
		inactiveBrothersItems () {
			this.items.forEach((item) => {
				item.isActive = false;
			});
		},
		activeParentItem (currentItem) {
			this.items.forEach((item) => {
				if (currentItem.title == item.title) item.isActive = true;
			});
		}
	}
};
</script>

<style lang="scss">

@import "../../scss/global.scss";
#sidemenu,
#sidemenu ul,
#sidemenu ul li,
#sidemenu ul li a {
  margin: 0;
  padding: 0;
  border: 0;
  list-style: none;
  line-height: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  &>span {
    color: $oxfordBlue;
  }
}
#sidemenu {
  background-color: $blank;
  border-right: 0.1rem solid $dawnBlue;
  margin-top: 6rem;
  width: 22rem;
  min-height: 100%;
}
//LEVEL 1
#sidemenu ul>li {
  border-bottom: 0.1rem solid $dawnBlue;
  justify-content: center;
  align-items: flex-start;
  &.exit a {
    font-weight: 400;
  }
  &.disabled a {
    color: $borderGrey;
    cursor: not-allowed;
    &:hover {
      background-color: transparent;
    }
  }
  &.disabled:first-child {
      & > a {
        color: $mustard;
      }
    }
}
#sidemenu>ul>li>a {
  justify-content: center;
  padding: 2.7rem 2rem;
  cursor: pointer;
  z-index: 2;
  font-size: $smallSize;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
  color: $oxfordBlue;
  height: 100%;
  width: 100%;
  transition: color 0.2s ease;
}
#sidemenu ul>li.open>a {
  font-weight: 700;
  color: $accentBlue;
}
#sidemenu>ul>li>a span {
  padding: 0;
  margin-top: 1.2rem;
  font-size: $mediumSize;
  font-weight: 400;
}
#sidemenu ul>li.open>a {
  border-bottom: 0.1rem solid $odd;
  font-weight: 700;
  color: $accentBlue;
}
#sidemenu>ul>li>a:hover {
  background-color: $liteGrey2;
}
//LEVEL 2
#sidemenu ul ul {
  background-color: $silkBlue;
  display: none;
  width: 100%;
}
#sidemenu>ul>li.active>ul {
  display: block;
}
#sidemenu ul ul li a {
  background: $blank;
  padding: 1rem 2rem;
  cursor: pointer;
  z-index: 2;
  font-size: $regularSize;
  text-decoration: none;
  color: $oxfordBlue;
  transition: color 0.2s ease;
  width: 100%;
}
#sidemenu ul ul li a:hover {
  background-color: $liteGrey2;
  width: 100%;
}
#sidemenu ul li.open>ul li {
  border-bottom: none;
  text-indent: 1.2rem;
  width: 100%;
  & a {
    width: 100%;
  }
}
#sidemenu ul>li.open>ul>li.open>a {
  color: $accentBlue;
}
//LEVEL 3
#sidemenu ul li.open>ul li.open>ul li {
  border-bottom: none;
  position: relative;
  font-size: $xsmallSize;
  &>a {
    font-size: $smallSize;
    padding-left: 4rem;
    &:before {
      content: '';
      border-radius: 1rem;
      width: 1rem;
      height: 1rem;
      position: absolute;
      top: 1.1rem;
      left: 2.7rem;
    }
  }
  &.cat0 {
    &>a {
      position: relative;
      &:before {
        background-image: url('../../assets/allCats2.svg');
        background-repeat: no-repeat;
        border-radius: 0;
        position: absolute;
        left: 2.6rem;
        top: 1.2rem;
        width: 1.1rem;
        height: 1.1rem;
      }
    }
  }
  &.cat1 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat1;
      }
    }
  }
  &.cat2 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat2;
      }
    }
  }
  &.cat3 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat3;
      }
    }
  }
  &.cat4 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat4;
      }
    }
  }
}
#sidemenu ul ul ul li a {
  font-size: $mediumSize;
}
#sidemenu ul li.open>ul li {
  border-bottom: 0.1rem solid $odd;
  width: 100%;
  &.teacher {
    & > a {
      padding-left: 1rem;
      font-size: $tinySize;
      font-weight: 400;
      }
    }
}
#sidemenu ul li.open>ul li a {
  width: 100%;
  &:last-child {
    border-bottom: none;
  }
}
#sidemenu ul li.open > ul li.open >ul li.open > a {
  color: $semiBlack;
  border-bottom: none;
}
#sidemenu ul li.open > ul li.open >ul li.open.openPath > a {
  color: $accentBlue;
  font-weight: 700;
}
#sidemenu ul>li.open>ul>li.open>a {
  color: $accentBlue;
}
#sidemenu ul ul ul li a {
  font-size: $smallSize;
  padding-left: 3rem;
}
//Level 3
#sidemenu ul li.open ul li.open ul li.open ul li a {
  background-color: #f5f9fd;
  padding-left: 5rem;
  font-size: $xsmallSize;
  color: $semiBlack;
}
#sidemenu ul li.open ul li.open ul li.open ul li {
  &>a {
    position: relative;
    padding-left: 5.5rem;
    &:before {
      content: '';
      border-radius: 1rem;
      width: 1rem;
      height: 1rem;
      position: absolute;
      top: 1rem;
      left: 4.2rem;
    }
  }
  &.cat0 {
    &>a {
      position: relative;
      &:before {
        background-image: url('../../assets/allCats2.svg');
        background-repeat: no-repeat;
        border-radius: 0;
        position: absolute;
        left: 4rem;
        top: 1rem;
        width: 1.1rem;
        height: 1.1rem;
      }
    }
  }
  &.cat1 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat1;
      }
    }
  }
  &.cat2 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat2;
      }
    }
  }
  &.cat3 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat3;
      }
    }
  }
  &.cat4 {
    &>a {
      position: relative;
      &:before {
        background-color: $cat4;
      }
    }
  }
}
#sidemenu ul li.open ul li.open ul li.open ul li.open ul li a {
  background-color: #ecf4fc;
  padding-left: 4.5rem;
}

.openPath {
  color: $accentBlue;
}

@media only screen and (max-width: 1170px) {
#sidemenu {
  box-shadow: 0 0.1rem 0.3rem 0.2rem $oxfordBlue;
  margin: 0;
  position: absolute;
  top: 6rem;
  left: -23rem;
  z-index: 20;
  transform: translate3d(0, 0, 0);
  transition-duration: 200ms;
  &.show {
    left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/SideBar.vue